import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Header from "../../../components/molecules/Header";
import useStyles from "./style";
import { useSnackbar } from "notistack";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockIcon from "@material-ui/icons/Lock";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import {
  Container,
  Button,
  OutlinedInput,
  InputLabel,
  FormControl,
  Divider,
  CircularProgress,
  Avatar,
} from "@material-ui/core";

import { useData } from "../../../components/firebase/DataProvider";

import Gap from "../../../components/atoms/Gap";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";

const defaultLogo = require("../../../assets/images/landing-image-third.png");

export default function UbahKataSandi() {
  const classes = useStyles();
  const { phone, profil, webstore } = useData();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({});
  const [showPass, setShowPass] = useState(false);
  const [showPassAgain, setShowPassAgain] = useState(false);
  const [showPassAgain2, setShowPassAgain2] = useState(false);

  const [isSubmitting, setSubmitting] = useState(false);
  const [currentName] = useState(profil.nama);

  const [currentWebstore] = useState({
    domain: `https://${webstore.domain}.tokorame.store`,
  });

  const handleShowPass = () => {
    if (showPass) {
      setShowPass(false);
    } else {
      setShowPass(true);
    }
  };

  const handleShowPassAgain = () => {
    if (showPassAgain) {
      setShowPassAgain(false);
    } else {
      setShowPassAgain(true);
    }
  };

  const handleShowPassAgain2 = () => {
    if (showPassAgain2) {
      setShowPassAgain2(false);
    } else {
      setShowPassAgain2(true);
    }
  };

  const handleChange = (name) => (values) => {
    // console.log('ini data', values.target.value)
    setForm({ ...form, [name]: values.target.value });
    setErrors({ ...errors, [name]: "" });
  };
  const validate = () => {
    let newErrors = {};

    if (!form.oldPassword) {
      newErrors.oldPassword = "Password Lama wajib diisi";
    } else if (form.oldPassword.length < 8) {
      newErrors.oldPassword = "Password minimal 8 karakter";
    }

    if (!form.newPassword) {
      newErrors.newPassword = "Password Lama wajib diisi";
    } else if (form.newPassword.length < 8) {
      newErrors.newPassword = "Password minimal 8 karakter";
    }

    if (!form.confirmNewPassword) {
      newErrors.confirmNewPassword = "Password Lama wajib diisi";
    } else if (form.confirmNewPassword.length < 8) {
      newErrors.confirmNewPassword = "Password minimal 8 karakter";
    } else if (form.newPassword !== form.confirmNewPassword) {
      newErrors.confirmNewPassword = "Kata sandi tidak sesuai";
    }

    return newErrors;
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    const findErrors = validate();
    // console.log("disni");
    if (Object.values(findErrors).some((message) => message !== "")) {
      setErrors(findErrors);
      setSubmitting(false);
      console.log("error");
    } else {
      try {
        // console.log("asasa");

        const auth = firefunctions.httpsCallable("loginByPhoneAndPassword");
        const setPassword = firefunctions.httpsCallable("setPassword");

        await auth({ no_hp: phone?.id, password: form.oldPassword });

        const response = await setPassword({ password: form.newPassword });

        history.push("/akun");

        enqueueSnackbar(`${response?.data?.message}!`, {
          variant: "success",
        });

        setSubmitting(false);
      } catch (e) {
        console.log(e);
        setSubmitting(false);
        setErrors((errors) => ({ ...errors, oldPassword: e.message }));
      }
    }
  };

  return (
    <>
      <Header
        title="Ubah Kata Sandi"
        type="with-title"
        onClick={() => history.goBack()}
      />
      <Gap height={15} />
      <Container>
        <div className={classes.wrapHeader}>
          <div className={classes.wrapAvatar}>
            <Avatar
              className={classes.large}
              src={!webstore.logo ? defaultLogo : webstore.logo}
            />
          </div>
          <Gap width={16} />
          <div>
            <p>{currentName}</p>
            <p>{phone?.id}</p>
            <p>{currentWebstore.domain}</p>
          </div>
        </div>
        <Divider />
        <div className={classes.content}>
          <form style={{ width: "100%" }}>
            <FormControl
              variant="outlined"
              fullWidth
              style={{ marginBottom: 25 }}
            >
              <InputLabel htmlFor="outlined-adornment-amount" slot="true">
                Kata Sandi Lama
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                placeholder="Kata Sandi Lama"
                error={errors.oldPassword ? true : false}
                value={form.oldPassword}
                type={showPass === true ? "text" : "password"}
                onChange={handleChange("oldPassword")}
                startAdornment={
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                }
                labelWidth={125}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleShowPass}
                      edge="end"
                    >
                      {showPass ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {errors.oldPassword ? (
                <div style={{ display: "flex", margin: 2 }}>
                  <span style={{ fontSize: 9, color: "red" }}>
                    {errors.oldPassword}
                  </span>
                </div>
              ) : null}
            </FormControl>
            <FormControl
              variant="outlined"
              fullWidth
              style={{ marginBottom: 25 }}
            >
              <InputLabel htmlFor="outlined-adornment-amount" slot="true">
                Kata Sandi Baru
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                placeholder="Kata Sandi Baru"
                error={errors.newPassword ? true : false}
                value={form.newPassword}
                type={showPassAgain === true ? "text" : "password"}
                onChange={handleChange("newPassword")}
                startAdornment={
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                }
                labelWidth={125}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleShowPassAgain}
                      edge="end"
                    >
                      {showPassAgain ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {errors.newPassword ? (
                <div style={{ display: "flex", margin: 2 }}>
                  <span style={{ fontSize: 9, color: "red" }}>
                    {errors.newPassword}
                  </span>
                </div>
              ) : null}
            </FormControl>
            <FormControl
              variant="outlined"
              fullWidth
              style={{ marginBottom: 20 }}
            >
              <InputLabel htmlFor="outlined-adornment-amount" slot="true">
                Konfirmasi Kata Sandi
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                placeholder="Konfirmasi Kata Sandi"
                error={errors.confirmNewPassword ? true : false}
                value={form.confirmNewPassword}
                type={showPassAgain2 === true ? "text" : "password"}
                onChange={handleChange("confirmNewPassword")}
                startAdornment={
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                }
                labelWidth={175}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleShowPassAgain2}
                      edge="end"
                    >
                      {showPassAgain2 ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {errors.confirmNewPassword ? (
                <div style={{ display: "flex", margin: 2 }}>
                  <span style={{ fontSize: 9, color: "red" }}>
                    {errors.confirmNewPassword}
                  </span>
                </div>
              ) : null}
            </FormControl>
          </form>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
            style={{
              position: "relative",
              letterSpacing: "1px",
              fontWeight: "bold",
              borderRadius: "8px",
              paddingTop: "12px",
              paddingBottom: "12px",
              bottom: 0,
              left: 0,
              width: "100%",
            }}
          >
            {isSubmitting === true && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
            {!isSubmitting ? "simpan Kata Sandi" : null}
          </Button>
        </div>
      </Container>
    </>
  );
}
